var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "show_overlay_dialog--container" },
    [
      !!_vm.dialogOptions
        ? _c("peppermill-dialog", {
            ref: "dialog",
            attrs: {
              title: _vm.options.confirmTitle,
              "label-confirm": _vm.options.confirmAccept,
              "label-deny": _vm.options.confirmDeny,
              "is-alert": _vm.options.alertMode,
              active: _vm.isActive,
              "link-ele": _vm.dialogLinkElement,
              wide: _vm.options.isWideUi,
              "hide-overlay": _vm.options.isOverlayHidden,
            },
            on: {
              close: function ($event) {
                _vm.isActive = false
              },
              submit: _vm.handleCallback,
              cancel: _vm.handleCallbackDeny,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.dialogBody) },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              4183231633
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }